import { getUserInfo } from '@/api/my'
// import { getAllFriend } from '@/api/im'
import { addressList } from '@/api/mall/mallLogistics'
import { getCashWallet } from '@/api/wallet/cash'

import { session } from '@/utils/session'
const state = {
  userInfo: {},// 登录后的用户信息
  friendList: [], // 好友列表
  shopListShow: false, // 钱包---钱包---现金余额---现金转账---> 是否展示店铺列表
  friendListShow: false, // 钱包---钱包---现金余额---现金转账---> 是否展示好友列表
  selectWallet: {}, // 钱包----现金----转移--->选中的钱包
  selectCard:{}, // 钱包---现金---提现---选中银行卡
  withdrawalData: {},// 钱包---现金---提现---提现申请参数
  //--------1.5.0-----------//
  sgOrderType: 0,// 商品订单，列表页头部 tab：0~4
  addressList: [],// 用地址列表
  addressListMap: {},// 用户地址列表-map
  addressSelectedId: '',//已选地址id
}

const mutations = {
  my_user_info: (state, userInfo) => {
    state.userInfo = userInfo
  },
  change_friend_list: (state, friendList) => {
    state.friendList = friendList
  },
  open_shop_list: state => {
    state.shopListShow = true
  },
  close_shop_list: state => {
    state.shopListShow = false
  },
  open_friend_list: state => {
    state.friendListShow = true
  },
  close_friend_list: state => {
    state.friendListShow = false
  },
  change_select_wallet: (state, selectWallet) => {
    state.selectWallet = selectWallet
  },
  change_select_card: (state, selectCard) => {
    state.selectCard = selectCard
  },
  //--------1.5.0-----------//
  change_sgOrderType: (state, type)=>{
    state.sgOrderType = type
  },
  change_addressSelectedId: (state, id) => {
    state.addressSelectedId = id
  },
  
  
}

const actions = {
  getMyUserInfo: ({ commit }) => {
    return new Promise((resolve, reject) => {
      getUserInfo({openId: session('userOpenId')}).then(res=>{
        const data = res.data;
        commit('my_user_info', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // changeFriendList: ({ commit }) => {
  //   return new Promise((resolve, reject) => {
  //     getAllFriend({accid: session('userOpenId')}).then(res=>{
  //       const fileServerDomain = session('user').fileServerDomain;
  //       const data = res.data || [];
  //       let friendList = data.map(item=>{
  //         item.avatar = item.avatar ? (fileServerDomain + item.avatar) : '/image/avatar.png';
  //         return item
  //       });
  //       commit('change_friend_list', friendList)
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  openFriendList: ({ commit }) => {
    commit('open_friend_list')
  },
  closeFriendList: ({ commit }) => {
    commit('close_friend_list')
  },
  openShopList: ({ commit }) => {
    commit('open_shop_list')
  },
  closeShopList: ({ commit }) => {
    commit('close_shop_list')
  },
  changeSelectWallet: ({ commit }, selectWallet) => {
    if(selectWallet.toWalletType===0){
      return new Promise((resolve, reject) => {
        getUserInfo({openId: selectWallet.data.friendAccid}).then(res=>{
          const select = selectWallet
          select.data.mobileNumber = res.data.phone || ''
          select.data.phone = (res.data.phone.substr(0,3) + '****' + res.data.phone.substr(7)) || '';
          commit('change_select_wallet', select)
          commit('close_friend_list')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }else if(selectWallet.toWalletType===1) {
      commit('change_select_wallet', selectWallet)
      commit('close_shop_list')
    }
  },
  changeSelectCard: ({ commit }, selectCard) => {
    commit('change_select_card', selectCard)
  },
  changeWithdrawalData: ({ state }, data) =>{
    let obj = Object.assign({}, data)
    state.withdrawalData = obj
  },
  //判断钱包是否有密码
  checkWalletHasPass: ({state, commit, dispatch}, req) => {
    return new Promise((resolve, reject) => {
      getCashWallet(req).then(res=>{
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //--------1.5.0-----------//
  getAddressList: ({state, commit, dispatch}, req) => {
    return new Promise((resolve, reject) => {
      addressList(req).then(res=>{
        if(res.code===200){
          dispatch('addressList', res.data)
        }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addressList: ({state, commit, dispatch}, data) => {
    let list = data.map(item=>{
      state.addressListMap[item.userAddressId] = item
      if(state.addressSelectedId){
        if(state.addressSelectedId===item.userAddressId){
          item.isShowActive = true
          // state.addressSelectedId = item.userAddressId
        }else {
          item.isShowActive = false
        }
      }else {
        if(item.isDefault){
          state.addressSelectedId = item.userAddressId
          item.isShowActive = true
        }else {
          item.isShowActive = false
        }
      }
      return item
    })
    state.addressList = list
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
